import React from 'react';
import {Font} from '../../../../../incase-domain/presentationTheme';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import MatchPairQuestionReport from './MatchPairQuestionReport';
import QuestionReportComponent from './QuestionReportComponent';
import {QuestionReport} from '../../../../../incase-domain/analytics';
import QuestionLayout from '../common/QuestionLayout';
import {QuestionnaireElementInteraction} from '../../../../../incase-domain/proptypes/runfile';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import ReportAnswerLikertScale from '../../../../../incase-domain/components/report/answer/likertScale/ReportAnswerLikertScale';
import SequenceQuestionReport from './SequenceQuestionReport';
import QuestionReportRespondents from './QuestionReportRespondents';

interface IRenderQuestionReportProps {
    question: IQuestionElements;
    questionReport: QuestionReport;
    fontFamily?: Font;
    device: DeviceType;
}

function RenderQuestionReport({question, device, fontFamily, questionReport}: IRenderQuestionReportProps): JSX.Element {
    const renderReport = (): JSX.Element => {
        switch (question?.type) {
            case ELEMENT.MATCH_PAIR_QUESTION:
                return <MatchPairQuestionReport questionReport={questionReport} device={device} />;
            case ELEMENT.LIKERT_SCALE:
                return <ReportAnswerLikertScale questionReport={questionReport} likertQuestions={question.questions} />;
            case ELEMENT.SEQUENCE_QUESTION:
                return <SequenceQuestionReport questionReport={questionReport} question={question} />;
            default:
                return <QuestionReportComponent element={question} questionReport={questionReport} />;
        }
    };

    if (!question) {
        return <></>;
    }

    return (
        <QuestionLayout
            element={question}
            device={device}
            elementInteractions={{} as QuestionnaireElementInteraction}
            hideCounter
            hideResults
            headerAddon={<QuestionReportRespondents count={questionReport.userAnsweredCount ?? questionReport.totalAnswers ?? 0} />}
        >
            <div
                style={{
                    fontFamily: fontFamily?.name,
                    fontSize: `${question?.fontSize || 'initial'}em`,
                }}
                className={`c-questionReport ${device === DeviceType.MOBILE ? 'c-questionReport--mobile' : ''}`}
            >
                {renderReport()}
            </div>
        </QuestionLayout>
    );
}

export default RenderQuestionReport;
